const _c0 = ["content"];
const _c1 = ["loadingicon"];
const _c2 = ["icon"];
const _c3 = ["*"];
const _c4 = (a0, a1) => ({
  class: a0,
  pt: a1
});
function Button_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function Button_ng_container_3_ng_container_1_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 7);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap(ctx_r0.cn(ctx_r0.cx("loadingIcon"), "pi-spin", ctx_r0.loadingIcon || (ctx_r0.buttonProps == null ? null : ctx_r0.buttonProps.loadingIcon)));
    i0.ɵɵproperty("pBind", ctx_r0.ptm("loadingIcon"));
    i0.ɵɵattribute("aria-hidden", true);
  }
}
function Button_ng_container_3_ng_container_1__svg_svg_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 8);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap(ctx_r0.cn(ctx_r0.cx("loadingIcon"), ctx_r0.cx("spinnerIcon")));
    i0.ɵɵproperty("pBind", ctx_r0.ptm("loadingIcon"))("spin", true);
    i0.ɵɵattribute("aria-hidden", true);
  }
}
function Button_ng_container_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, Button_ng_container_3_ng_container_1_span_1_Template, 1, 4, "span", 3)(2, Button_ng_container_3_ng_container_1__svg_svg_2_Template, 1, 5, "svg", 6);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.loadingIcon || (ctx_r0.buttonProps == null ? null : ctx_r0.buttonProps.loadingIcon));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !(ctx_r0.loadingIcon || (ctx_r0.buttonProps == null ? null : ctx_r0.buttonProps.loadingIcon)));
  }
}
function Button_ng_container_3_2_ng_template_0_Template(rf, ctx) {}
function Button_ng_container_3_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Button_ng_container_3_2_ng_template_0_Template, 0, 0, "ng-template", 9);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r0.loadingIconTemplate || ctx_r0._loadingIconTemplate);
  }
}
function Button_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, Button_ng_container_3_ng_container_1_Template, 3, 2, "ng-container", 2)(2, Button_ng_container_3_2_Template, 1, 1, null, 5);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.loadingIconTemplate && !ctx_r0._loadingIconTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.loadingIconTemplate || ctx_r0._loadingIconTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction2(3, _c4, ctx_r0.cx("loadingIcon"), ctx_r0.ptm("loadingIcon")));
  }
}
function Button_ng_container_4_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 7);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(ctx_r0.cn(ctx_r0.cx("icon"), ctx_r0.icon || (ctx_r0.buttonProps == null ? null : ctx_r0.buttonProps.icon)));
    i0.ɵɵproperty("pBind", ctx_r0.ptm("icon"));
    i0.ɵɵattribute("data-p", ctx_r0.dataIconP);
  }
}
function Button_ng_container_4_2_ng_template_0_Template(rf, ctx) {}
function Button_ng_container_4_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Button_ng_container_4_2_ng_template_0_Template, 0, 0, "ng-template", 9);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", !ctx_r0.icon && (ctx_r0.iconTemplate || ctx_r0._iconTemplate));
  }
}
function Button_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, Button_ng_container_4_span_1_Template, 1, 4, "span", 3)(2, Button_ng_container_4_2_Template, 1, 1, null, 5);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r0.icon || (ctx_r0.buttonProps == null ? null : ctx_r0.buttonProps.icon)) && !ctx_r0.iconTemplate && !ctx_r0._iconTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.iconTemplate || ctx_r0._iconTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction2(3, _c4, ctx_r0.cx("icon"), ctx_r0.ptm("icon")));
  }
}
function Button_span_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 7);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r0.cx("label"));
    i0.ɵɵproperty("pBind", ctx_r0.ptm("label"));
    i0.ɵɵattribute("aria-hidden", (ctx_r0.icon || (ctx_r0.buttonProps == null ? null : ctx_r0.buttonProps.icon)) && !(ctx_r0.label || (ctx_r0.buttonProps == null ? null : ctx_r0.buttonProps.label)))("data-p", ctx_r0.dataLabelP);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.label || (ctx_r0.buttonProps == null ? null : ctx_r0.buttonProps.label));
  }
}
function Button_p_badge_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "p-badge", 10);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("value", ctx_r0.badge || (ctx_r0.buttonProps == null ? null : ctx_r0.buttonProps.badge))("severity", ctx_r0.badgeSeverity || (ctx_r0.buttonProps == null ? null : ctx_r0.buttonProps.badgeSeverity))("pt", ctx_r0.ptm("pcBadge"))("unstyled", ctx_r0.unstyled());
  }
}
export * from 'primeng/types/button';
import * as i2 from '@angular/common';
import { isPlatformBrowser, CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Injectable, InjectionToken, input, inject, effect, Directive, booleanAttribute, contentChild, computed, Input, EventEmitter, numberAttribute, ContentChildren, ContentChild, Output, ViewEncapsulation, ChangeDetectionStrategy, Component, NgModule } from '@angular/core';
import { addClass, isEmpty, findSingle, createElement } from '@primeuix/utils';
import { SharedModule, PrimeTemplate } from 'primeng/api';
import { AutoFocus } from 'primeng/autofocus';
import * as i3 from 'primeng/badge';
import { BadgeModule } from 'primeng/badge';
import { BaseComponent, PARENT_INSTANCE } from 'primeng/basecomponent';
import * as i1 from 'primeng/bind';
import { Bind } from 'primeng/bind';
import { Fluid } from 'primeng/fluid';
import { SpinnerIcon } from 'primeng/icons';
import { Ripple } from 'primeng/ripple';
import { style } from '@primeuix/styles/button';
import { BaseStyle } from 'primeng/base';
const classes = {
  root: ({
    instance
  }) => ['p-button p-component', {
    'p-button-icon-only': instance.hasIcon && !instance.label && !instance.buttonProps?.label && !instance.badge,
    'p-button-vertical': (instance.iconPos === 'top' || instance.iconPos === 'bottom') && instance.label,
    'p-button-loading': instance.loading || instance.buttonProps?.loading,
    'p-button-link': instance.link || instance.buttonProps?.link,
    [`p-button-${instance.severity || instance.buttonProps?.severity}`]: instance.severity || instance.buttonProps?.severity,
    'p-button-raised': instance.raised || instance.buttonProps?.raised,
    'p-button-rounded': instance.rounded || instance.buttonProps?.rounded,
    'p-button-text': instance.text || instance.variant === 'text' || instance.buttonProps?.text || instance.buttonProps?.variant === 'text',
    'p-button-outlined': instance.outlined || instance.variant === 'outlined' || instance.buttonProps?.outlined || instance.buttonProps?.variant === 'outlined',
    'p-button-sm': instance.size === 'small' || instance.buttonProps?.size === 'small',
    'p-button-lg': instance.size === 'large' || instance.buttonProps?.size === 'large',
    'p-button-plain': instance.plain || instance.buttonProps?.plain,
    'p-button-fluid': instance.hasFluid
  }],
  loadingIcon: 'p-button-loading-icon',
  icon: ({
    instance
  }) => ['p-button-icon', {
    [`p-button-icon-${instance.iconPos || instance.buttonProps?.iconPos}`]: instance.label || instance.buttonProps?.label,
    'p-button-icon-left': (instance.iconPos === 'left' || instance.buttonProps?.iconPos === 'left') && instance.label || instance.buttonProps?.label,
    'p-button-icon-right': (instance.iconPos === 'right' || instance.buttonProps?.iconPos === 'right') && instance.label || instance.buttonProps?.label,
    'p-button-icon-top': (instance.iconPos === 'top' || instance.buttonProps?.iconPos === 'top') && instance.label || instance.buttonProps?.label,
    'p-button-icon-bottom': (instance.iconPos === 'bottom' || instance.buttonProps?.iconPos === 'bottom') && instance.label || instance.buttonProps?.label
  }, instance.icon, instance.buttonProps?.icon],
  spinnerIcon: ({
    instance
  }) => {
    return Object.entries(instance.cx('icon')).filter(([, value]) => !!value).reduce((acc, [key]) => acc + ` ${key}`, 'p-button-loading-icon');
  },
  label: 'p-button-label'
};
let ButtonStyle = /*#__PURE__*/(() => {
  class ButtonStyle extends BaseStyle {
    name = 'button';
    style = style;
    classes = classes;
    static ɵfac = /* @__PURE__ */(() => {
      let ɵButtonStyle_BaseFactory;
      return function ButtonStyle_Factory(__ngFactoryType__) {
        return (ɵButtonStyle_BaseFactory || (ɵButtonStyle_BaseFactory = i0.ɵɵgetInheritedFactory(ButtonStyle)))(__ngFactoryType__ || ButtonStyle);
      };
    })();
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ButtonStyle,
      factory: ButtonStyle.ɵfac
    });
  }
  return ButtonStyle;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 *
 * Button is an extension to standard button element with icons and theming.
 *
 * [Live Demo](https://www.primeng.org/button/)
 *
 * @module buttonstyle
 *
 */
var ButtonClasses = /*#__PURE__*/function (ButtonClasses) {
  /**
   * Class name of the root element
   */
  ButtonClasses["root"] = "p-button";
  /**
   * Class name of the loading icon element
   */
  ButtonClasses["loadingIcon"] = "p-button-loading-icon";
  /**
   * Class name of the icon element
   */
  ButtonClasses["icon"] = "p-button-icon";
  /**
   * Class name of the label element
   */
  ButtonClasses["label"] = "p-button-label";
  return ButtonClasses;
}(ButtonClasses || {});
const BUTTON_INSTANCE = /*#__PURE__*/new InjectionToken('BUTTON_INSTANCE');
const BUTTON_DIRECTIVE_INSTANCE = /*#__PURE__*/new InjectionToken('BUTTON_DIRECTIVE_INSTANCE');
const BUTTON_LABEL_INSTANCE = /*#__PURE__*/new InjectionToken('BUTTON_LABEL_INSTANCE');
const BUTTON_ICON_INSTANCE = /*#__PURE__*/new InjectionToken('BUTTON_ICON_INSTANCE');
const INTERNAL_BUTTON_CLASSES = {
  button: 'p-button',
  component: 'p-component',
  iconOnly: 'p-button-icon-only',
  disabled: 'p-disabled',
  loading: 'p-button-loading',
  labelOnly: 'p-button-loading-label-only'
};
let ButtonLabel = /*#__PURE__*/(() => {
  class ButtonLabel extends BaseComponent {
    componentName = 'ButtonLabel';
    /**
     * Used to pass attributes to DOM elements inside the pButtonLabel.
     * @defaultValue undefined
     * @deprecated use pButtonLabelPT instead.
     * @group Props
     */
    ptButtonLabel = input(...(ngDevMode ? [undefined, {
      debugName: "ptButtonLabel"
    }] : []));
    /**
     * Used to pass attributes to DOM elements inside the pButtonLabel.
     * @defaultValue undefined
     * @group Props
     */
    pButtonLabelPT = input(...(ngDevMode ? [undefined, {
      debugName: "pButtonLabelPT"
    }] : []));
    /**
     * Indicates whether the component should be rendered without styles.
     * @defaultValue undefined
     * @group Props
     */
    pButtonLabelUnstyled = input(...(ngDevMode ? [undefined, {
      debugName: "pButtonLabelUnstyled"
    }] : []));
    $pcButtonLabel = inject(BUTTON_LABEL_INSTANCE, {
      optional: true,
      skipSelf: true
    }) ?? undefined;
    bindDirectiveInstance = inject(Bind, {
      self: true
    });
    constructor() {
      super();
      effect(() => {
        const pt = this.ptButtonLabel() || this.pButtonLabelPT();
        pt && this.directivePT.set(pt);
      });
      effect(() => {
        this.pButtonLabelUnstyled() && this.directiveUnstyled.set(this.pButtonLabelUnstyled());
      });
    }
    onAfterViewChecked() {
      this.bindDirectiveInstance.setAttrs(this.ptms(['host', 'root']));
    }
    static ɵfac = function ButtonLabel_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ButtonLabel)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ButtonLabel,
      selectors: [["", "pButtonLabel", ""]],
      hostVars: 2,
      hostBindings: function ButtonLabel_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("p-button-label", !ctx.$unstyled() && true);
        }
      },
      inputs: {
        ptButtonLabel: [1, "ptButtonLabel"],
        pButtonLabelPT: [1, "pButtonLabelPT"],
        pButtonLabelUnstyled: [1, "pButtonLabelUnstyled"]
      },
      features: [i0.ɵɵProvidersFeature([ButtonStyle, {
        provide: BUTTON_LABEL_INSTANCE,
        useExisting: ButtonLabel
      }, {
        provide: PARENT_INSTANCE,
        useExisting: ButtonLabel
      }]), i0.ɵɵHostDirectivesFeature([i1.Bind]), i0.ɵɵInheritDefinitionFeature]
    });
  }
  return ButtonLabel;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ButtonIcon = /*#__PURE__*/(() => {
  class ButtonIcon extends BaseComponent {
    componentName = 'ButtonIcon';
    /**
     * Used to pass attributes to DOM elements inside the pButtonIcon.
     * @defaultValue undefined
     * @deprecated use pButtonIconPT instead.
     * @group Props
     */
    ptButtonIcon = input(...(ngDevMode ? [undefined, {
      debugName: "ptButtonIcon"
    }] : []));
    /**
     * Used to pass attributes to DOM elements inside the pButtonIcon.
     * @defaultValue undefined
     * @group Props
     */
    pButtonIconPT = input(...(ngDevMode ? [undefined, {
      debugName: "pButtonIconPT"
    }] : []));
    /**
     * Indicates whether the component should be rendered without styles.
     * @defaultValue undefined
     * @group Props
     */
    pButtonUnstyled = input(...(ngDevMode ? [undefined, {
      debugName: "pButtonUnstyled"
    }] : []));
    $pcButtonIcon = inject(BUTTON_ICON_INSTANCE, {
      optional: true,
      skipSelf: true
    }) ?? undefined;
    bindDirectiveInstance = inject(Bind, {
      self: true
    });
    constructor() {
      super();
      effect(() => {
        const pt = this.ptButtonIcon() || this.pButtonIconPT();
        pt && this.directivePT.set(pt);
      });
      effect(() => {
        this.pButtonUnstyled() && this.directiveUnstyled.set(this.pButtonUnstyled());
      });
    }
    onAfterViewChecked() {
      this.bindDirectiveInstance.setAttrs(this.ptms(['host', 'root']));
    }
    static ɵfac = function ButtonIcon_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ButtonIcon)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ButtonIcon,
      selectors: [["", "pButtonIcon", ""]],
      hostVars: 2,
      hostBindings: function ButtonIcon_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("p-button-icon", !ctx.$unstyled() && true);
        }
      },
      inputs: {
        ptButtonIcon: [1, "ptButtonIcon"],
        pButtonIconPT: [1, "pButtonIconPT"],
        pButtonUnstyled: [1, "pButtonUnstyled"]
      },
      features: [i0.ɵɵProvidersFeature([ButtonStyle, {
        provide: BUTTON_ICON_INSTANCE,
        useExisting: ButtonIcon
      }, {
        provide: PARENT_INSTANCE,
        useExisting: ButtonIcon
      }]), i0.ɵɵHostDirectivesFeature([i1.Bind]), i0.ɵɵInheritDefinitionFeature]
    });
  }
  return ButtonIcon;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * Button directive is an extension to button component.
 * @group Components
 */
let ButtonDirective = /*#__PURE__*/(() => {
  class ButtonDirective extends BaseComponent {
    componentName = 'Button';
    $pcButtonDirective = inject(BUTTON_DIRECTIVE_INSTANCE, {
      optional: true,
      skipSelf: true
    }) ?? undefined;
    bindDirectiveInstance = inject(Bind, {
      self: true
    });
    _componentStyle = inject(ButtonStyle);
    /**
     * Used to pass attributes to DOM elements inside the Button component.
     * @defaultValue undefined
     * @deprecated use pButtonPT instead.
     * @group Props
     */
    ptButtonDirective = input(...(ngDevMode ? [undefined, {
      debugName: "ptButtonDirective"
    }] : []));
    /**
     * Used to pass attributes to DOM elements inside the Button component.
     * @defaultValue undefined
     * @group Props
     */
    pButtonPT = input(...(ngDevMode ? [undefined, {
      debugName: "pButtonPT"
    }] : []));
    /**
     * Indicates whether the component should be rendered without styles.
     * @defaultValue undefined
     * @group Props
     */
    pButtonUnstyled = input(...(ngDevMode ? [undefined, {
      debugName: "pButtonUnstyled"
    }] : []));
    hostName = '';
    onAfterViewChecked() {
      this.bindDirectiveInstance.setAttrs(this.ptm('root'));
    }
    constructor() {
      super();
      effect(() => {
        const pt = this.ptButtonDirective() || this.pButtonPT();
        pt && this.directivePT.set(pt);
      });
      effect(() => {
        this.pButtonUnstyled() && this.directiveUnstyled.set(this.pButtonUnstyled());
      });
      effect(() => {
        const unstyled = this.$unstyled();
        if (this.initialized && unstyled) {
          this.setStyleClass();
        }
      });
    }
    /**
     * Add a textual class to the button without a background initially.
     * @group Props
     */
    text = false;
    /**
     * Add a plain textual class to the button without a background initially.
     * @group Props
     */
    plain = false;
    /**
     * Add a shadow to indicate elevation.
     * @group Props
     */
    raised = false;
    /**
     * Defines the size of the button.
     * @group Props
     */
    size;
    /**
     * Add a border class without a background initially.
     * @group Props
     */
    outlined = false;
    /**
     * Add a circular border radius to the button.
     * @group Props
     */
    rounded = false;
    /**
     * Position of the icon.
     * @group Props
     */
    iconPos = 'left';
    /**
     * Icon to display in loading state.
     * @group Props
     */
    loadingIcon;
    /**
     * Spans 100% width of the container when enabled.
     * @defaultValue undefined
     * @group Props
     */
    fluid = input(undefined, {
      ...(ngDevMode ? {
        debugName: "fluid"
      } : {}),
      transform: booleanAttribute
    });
    iconSignal = contentChild(ButtonIcon, ...(ngDevMode ? [{
      debugName: "iconSignal"
    }] : []));
    labelSignal = contentChild(ButtonLabel, ...(ngDevMode ? [{
      debugName: "labelSignal"
    }] : []));
    isIconOnly = computed(() => !!(!this.labelSignal() && this.iconSignal()), ...(ngDevMode ? [{
      debugName: "isIconOnly"
    }] : []));
    _label;
    _icon;
    _loading = false;
    _severity;
    _buttonProps;
    initialized;
    get htmlElement() {
      return this.el.nativeElement;
    }
    _internalClasses = Object.values(INTERNAL_BUTTON_CLASSES);
    pcFluid = inject(Fluid, {
      optional: true,
      host: true,
      skipSelf: true
    });
    isTextButton = computed(() => !!(!this.iconSignal() && this.labelSignal() && this.text), ...(ngDevMode ? [{
      debugName: "isTextButton"
    }] : []));
    /**
     * Text of the button.
     * @deprecated use pButtonLabel directive instead.
     * @group Props
     */
    get label() {
      return this._label;
    }
    set label(val) {
      this._label = val;
      if (this.initialized) {
        this.updateLabel();
        this.updateIcon();
        this.setStyleClass();
      }
    }
    /**
     * Name of the icon.
     * @deprecated use pButtonIcon directive instead
     * @group Props
     */
    get icon() {
      return this._icon;
    }
    set icon(val) {
      this._icon = val;
      if (this.initialized) {
        this.updateIcon();
        this.setStyleClass();
      }
    }
    /**
     * Whether the button is in loading state.
     * @group Props
     */
    get loading() {
      return this._loading;
    }
    set loading(val) {
      this._loading = val;
      if (this.initialized) {
        this.updateIcon();
        this.setStyleClass();
      }
    }
    /**
     * Used to pass all properties of the ButtonProps to the Button component.
     * @deprecated assign props directly to the button element.
     * @group Props
     */
    get buttonProps() {
      return this._buttonProps;
    }
    set buttonProps(val) {
      this._buttonProps = val;
      if (val && typeof val === 'object') {
        //@ts-ignore
        Object.entries(val).forEach(([k, v]) => this[`_${k}`] !== v && (this[`_${k}`] = v));
      }
    }
    /**
     * Defines the style of the button.
     * @group Props
     */
    get severity() {
      return this._severity;
    }
    set severity(value) {
      this._severity = value;
      if (this.initialized) {
        this.setStyleClass();
      }
    }
    spinnerIcon = `<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" class="p-icon-spin">
        <g clip-path="url(#clip0_417_21408)">
            <path
                d="M6.99701 14C5.85441 13.999 4.72939 13.7186 3.72012 13.1832C2.71084 12.6478 1.84795 11.8737 1.20673 10.9284C0.565504 9.98305 0.165424 8.89526 0.041387 7.75989C-0.0826496 6.62453 0.073125 5.47607 0.495122 4.4147C0.917119 3.35333 1.59252 2.4113 2.46241 1.67077C3.33229 0.930247 4.37024 0.413729 5.4857 0.166275C6.60117 -0.0811796 7.76026 -0.0520535 8.86188 0.251112C9.9635 0.554278 10.9742 1.12227 11.8057 1.90555C11.915 2.01493 11.9764 2.16319 11.9764 2.31778C11.9764 2.47236 11.915 2.62062 11.8057 2.73C11.7521 2.78503 11.688 2.82877 11.6171 2.85864C11.5463 2.8885 11.4702 2.90389 11.3933 2.90389C11.3165 2.90389 11.2404 2.8885 11.1695 2.85864C11.0987 2.82877 11.0346 2.78503 10.9809 2.73C9.9998 1.81273 8.73246 1.26138 7.39226 1.16876C6.05206 1.07615 4.72086 1.44794 3.62279 2.22152C2.52471 2.99511 1.72683 4.12325 1.36345 5.41602C1.00008 6.70879 1.09342 8.08723 1.62775 9.31926C2.16209 10.5513 3.10478 11.5617 4.29713 12.1803C5.48947 12.7989 6.85865 12.988 8.17414 12.7157C9.48963 12.4435 10.6711 11.7264 11.5196 10.6854C12.3681 9.64432 12.8319 8.34282 12.8328 7C12.8328 6.84529 12.8943 6.69692 13.0038 6.58752C13.1132 6.47812 13.2616 6.41667 13.4164 6.41667C13.5712 6.41667 13.7196 6.47812 13.8291 6.58752C13.9385 6.69692 14 6.84529 14 7C14 8.85651 13.2622 10.637 11.9489 11.9497C10.6356 13.2625 8.85432 14 6.99701 14Z"
                fill="currentColor"
            />
        </g>
        <defs>
            <clipPath id="clip0_417_21408">
                <rect width="14" height="14" fill="white" />
            </clipPath>
        </defs>
    </svg>`;
    onAfterViewInit() {
      !this.$unstyled() && addClass(this.htmlElement, this.getStyleClass().join(' '));
      if (isPlatformBrowser(this.platformId)) {
        this.createIcon();
        this.createLabel();
        this.initialized = true;
      }
    }
    getStyleClass() {
      const styleClass = [INTERNAL_BUTTON_CLASSES.button, INTERNAL_BUTTON_CLASSES.component];
      if (this.icon && !this.label && isEmpty(this.htmlElement.textContent)) {
        styleClass.push(INTERNAL_BUTTON_CLASSES.iconOnly);
      }
      if (this.loading) {
        styleClass.push(INTERNAL_BUTTON_CLASSES.disabled, INTERNAL_BUTTON_CLASSES.loading);
        if (!this.icon && this.label) {
          styleClass.push(INTERNAL_BUTTON_CLASSES.labelOnly);
        }
        if (this.icon && !this.label && !isEmpty(this.htmlElement.textContent)) {
          styleClass.push(INTERNAL_BUTTON_CLASSES.iconOnly);
        }
      }
      if (this.text) {
        styleClass.push('p-button-text');
      }
      if (this.severity) {
        styleClass.push(`p-button-${this.severity}`);
      }
      if (this.plain) {
        styleClass.push('p-button-plain');
      }
      if (this.raised) {
        styleClass.push('p-button-raised');
      }
      if (this.size) {
        styleClass.push(`p-button-${this.size}`);
      }
      if (this.outlined) {
        styleClass.push('p-button-outlined');
      }
      if (this.rounded) {
        styleClass.push('p-button-rounded');
      }
      if (this.size === 'small') {
        styleClass.push('p-button-sm');
      }
      if (this.size === 'large') {
        styleClass.push('p-button-lg');
      }
      if (this.hasFluid) {
        styleClass.push('p-button-fluid');
      }
      return this.$unstyled() ? [] : styleClass;
    }
    get hasFluid() {
      return this.fluid() ?? !!this.pcFluid;
    }
    setStyleClass() {
      const styleClass = this.getStyleClass();
      this.removeExistingSeverityClass();
      this.htmlElement.classList.remove(...this._internalClasses);
      this.htmlElement.classList.add(...styleClass);
    }
    removeExistingSeverityClass() {
      const severityArray = ['success', 'info', 'warn', 'danger', 'help', 'primary', 'secondary', 'contrast'];
      const existingSeverityClass = this.htmlElement.classList.value.split(' ').find(cls => severityArray.some(severity => cls === `p-button-${severity}`));
      if (existingSeverityClass) {
        this.htmlElement.classList.remove(existingSeverityClass);
      }
    }
    createLabel() {
      const created = findSingle(this.htmlElement, '[data-pc-section="buttonlabel"]');
      if (!created && this.label) {
        let labelElement = createElement('span', {
          class: this.cx('label'),
          'p-bind': this.ptm('buttonlabel'),
          'aria-hidden': this.icon && !this.label ? 'true' : null
        });
        labelElement.appendChild(this.document.createTextNode(this.label));
        this.htmlElement.appendChild(labelElement);
      }
    }
    createIcon() {
      const created = findSingle(this.htmlElement, '[data-pc-section="buttonicon"]');
      if (!created && (this.icon || this.loading)) {
        let iconPosClass = this.label && !this.$unstyled() ? 'p-button-icon-' + this.iconPos : null;
        let iconClass = !this.$unstyled() && this.getIconClass();
        let iconElement = createElement('span', {
          class: this.cn(this.cx('icon'), iconPosClass, iconClass),
          'aria-hidden': 'true',
          'p-bind': this.ptm('buttonicon')
        });
        if (!this.loadingIcon && this.loading) {
          iconElement.innerHTML = this.spinnerIcon;
        }
        this.htmlElement.insertBefore(iconElement, this.htmlElement.firstChild);
      }
    }
    updateLabel() {
      let labelElement = findSingle(this.htmlElement, '[data-pc-section="buttonlabel"]');
      if (!this.label) {
        labelElement && this.htmlElement.removeChild(labelElement);
        return;
      }
      labelElement ? labelElement.textContent = this.label : this.createLabel();
    }
    updateIcon() {
      let iconElement = findSingle(this.htmlElement, '[data-pc-section="buttonicon"]');
      let labelElement = findSingle(this.htmlElement, '[data-pc-section="buttonlabel"]');
      if (this.loading && !this.loadingIcon && iconElement) {
        iconElement.innerHTML = this.spinnerIcon;
      } else if (iconElement?.innerHTML) {
        iconElement.innerHTML = '';
      }
      if (iconElement && !this.$unstyled()) {
        if (this.iconPos) {
          iconElement.className = 'p-button-icon ' + (labelElement ? 'p-button-icon-' + this.iconPos : '') + ' ' + this.getIconClass();
        } else {
          iconElement.className = 'p-button-icon ' + this.getIconClass();
        }
      } else {
        this.createIcon();
      }
    }
    getIconClass() {
      return this.loading ? 'p-button-loading-icon ' + (this.loadingIcon ? this.loadingIcon : 'p-icon') : this.icon || 'p-hidden';
    }
    onDestroy() {
      this.initialized = false;
    }
    static ɵfac = function ButtonDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ButtonDirective)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ButtonDirective,
      selectors: [["", "pButton", ""]],
      contentQueries: function ButtonDirective_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuerySignal(dirIndex, ctx.iconSignal, ButtonIcon, 5)(dirIndex, ctx.labelSignal, ButtonLabel, 5);
        }
        if (rf & 2) {
          i0.ɵɵqueryAdvance(2);
        }
      },
      hostVars: 4,
      hostBindings: function ButtonDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("p-button-icon-only", !ctx.$unstyled() && ctx.isIconOnly())("p-button-text", !ctx.$unstyled() && ctx.isTextButton());
        }
      },
      inputs: {
        ptButtonDirective: [1, "ptButtonDirective"],
        pButtonPT: [1, "pButtonPT"],
        pButtonUnstyled: [1, "pButtonUnstyled"],
        hostName: "hostName",
        text: [2, "text", "text", booleanAttribute],
        plain: [2, "plain", "plain", booleanAttribute],
        raised: [2, "raised", "raised", booleanAttribute],
        size: "size",
        outlined: [2, "outlined", "outlined", booleanAttribute],
        rounded: [2, "rounded", "rounded", booleanAttribute],
        iconPos: "iconPos",
        loadingIcon: "loadingIcon",
        fluid: [1, "fluid"],
        label: "label",
        icon: "icon",
        loading: "loading",
        buttonProps: "buttonProps",
        severity: "severity"
      },
      features: [i0.ɵɵProvidersFeature([ButtonStyle, {
        provide: BUTTON_DIRECTIVE_INSTANCE,
        useExisting: ButtonDirective
      }, {
        provide: PARENT_INSTANCE,
        useExisting: ButtonDirective
      }]), i0.ɵɵHostDirectivesFeature([i1.Bind]), i0.ɵɵInheritDefinitionFeature]
    });
  }
  return ButtonDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * Button is an extension to standard button element with icons and theming.
 * @group Components
 */
let Button = /*#__PURE__*/(() => {
  class Button extends BaseComponent {
    componentName = 'Button';
    hostName = '';
    $pcButton = inject(BUTTON_INSTANCE, {
      optional: true,
      skipSelf: true
    }) ?? undefined;
    bindDirectiveInstance = inject(Bind, {
      self: true
    });
    _componentStyle = inject(ButtonStyle);
    onAfterViewChecked() {
      this.bindDirectiveInstance.setAttrs(this.ptm('host'));
    }
    /**
     * Type of the button.
     * @group Props
     */
    type = 'button';
    /**
     * Value of the badge.
     * @group Props
     */
    badge;
    /**
     * When present, it specifies that the component should be disabled.
     * @group Props
     */
    disabled;
    /**
     * Add a shadow to indicate elevation.
     * @group Props
     */
    raised = false;
    /**
     * Add a circular border radius to the button.
     * @group Props
     */
    rounded = false;
    /**
     * Add a textual class to the button without a background initially.
     * @group Props
     */
    text = false;
    /**
     * Add a plain textual class to the button without a background initially.
     * @group Props
     */
    plain = false;
    /**
     * Add a border class without a background initially.
     * @group Props
     */
    outlined = false;
    /**
     * Add a link style to the button.
     * @group Props
     */
    link = false;
    /**
     * Add a tabindex to the button.
     * @group Props
     */
    tabindex;
    /**
     * Defines the size of the button.
     * @group Props
     */
    size;
    /**
     * Specifies the variant of the component.
     * @group Props
     */
    variant;
    /**
     * Inline style of the element.
     * @group Props
     */
    style;
    /**
     * Class of the element.
     * @group Props
     */
    styleClass;
    /**
     * Style class of the badge.
     * @group Props
     * @deprecated use badgeSeverity instead.
     */
    badgeClass;
    /**
     * Severity type of the badge.
     * @group Props
     * @defaultValue secondary
     */
    badgeSeverity = 'secondary';
    /**
     * Used to define a string that autocomplete attribute the current element.
     * @group Props
     */
    ariaLabel;
    /**
     * When present, it specifies that the component should automatically get focus on load.
     * @group Props
     */
    autofocus;
    /**
     * Position of the icon.
     * @group Props
     */
    iconPos = 'left';
    /**
     * Name of the icon.
     * @group Props
     */
    icon;
    /**
     * Text of the button.
     * @group Props
     */
    label;
    /**
     * Whether the button is in loading state.
     * @group Props
     */
    loading = false;
    /**
     * Icon to display in loading state.
     * @group Props
     */
    loadingIcon;
    /**
     * Defines the style of the button.
     * @group Props
     */
    severity;
    /**
     * Used to pass all properties of the ButtonProps to the Button component.
     * @group Props
     */
    buttonProps;
    /**
     * Spans 100% width of the container when enabled.
     * @defaultValue undefined
     * @group Props
     */
    fluid = input(undefined, {
      ...(ngDevMode ? {
        debugName: "fluid"
      } : {}),
      transform: booleanAttribute
    });
    /**
     * Callback to execute when button is clicked.
     * This event is intended to be used with the <p-button> component. Using a regular <button> element, use (click).
     * @param {MouseEvent} event - Mouse event.
     * @group Emits
     */
    onClick = new EventEmitter();
    /**
     * Callback to execute when button is focused.
     * This event is intended to be used with the <p-button> component. Using a regular <button> element, use (focus).
     * @param {FocusEvent} event - Focus event.
     * @group Emits
     */
    onFocus = new EventEmitter();
    /**
     * Callback to execute when button loses focus.
     * This event is intended to be used with the <p-button> component. Using a regular <button> element, use (blur).
     * @param {FocusEvent} event - Focus event.
     * @group Emits
     */
    onBlur = new EventEmitter();
    /**
     * Custom content template.
     * @group Templates
     **/
    contentTemplate;
    /**
     * Custom loading icon template.
     * @group Templates
     **/
    loadingIconTemplate;
    /**
     * Custom icon template.
     * @group Templates
     **/
    iconTemplate;
    templates;
    pcFluid = inject(Fluid, {
      optional: true,
      host: true,
      skipSelf: true
    });
    get hasFluid() {
      return this.fluid() ?? !!this.pcFluid;
    }
    get hasIcon() {
      return this.icon || this.buttonProps?.icon || this.iconTemplate || this._iconTemplate || this.loadingIcon || this.loadingIconTemplate || this._loadingIconTemplate;
    }
    _contentTemplate;
    _iconTemplate;
    _loadingIconTemplate;
    onAfterContentInit() {
      this.templates?.forEach(item => {
        switch (item.getType()) {
          case 'content':
            this._contentTemplate = item.template;
            break;
          case 'icon':
            this._iconTemplate = item.template;
            break;
          case 'loadingicon':
            this._loadingIconTemplate = item.template;
            break;
          default:
            this._contentTemplate = item.template;
            break;
        }
      });
    }
    get dataP() {
      return this.cn({
        [this.size]: this.size,
        'icon-only': this.hasIcon && !this.label && !this.badge,
        loading: this.loading,
        fluid: this.hasFluid,
        rounded: this.rounded,
        raised: this.raised,
        outlined: this.outlined || this.variant === 'outlined',
        text: this.text || this.variant === 'text',
        link: this.link,
        vertical: (this.iconPos === 'top' || this.iconPos === 'bottom') && this.label
      });
    }
    get dataIconP() {
      return this.cn({
        [this.iconPos]: this.iconPos,
        [this.size]: this.size
      });
    }
    get dataLabelP() {
      return this.cn({
        [this.size]: this.size,
        'icon-only': this.hasIcon && !this.label && !this.badge
      });
    }
    static ɵfac = /* @__PURE__ */(() => {
      let ɵButton_BaseFactory;
      return function Button_Factory(__ngFactoryType__) {
        return (ɵButton_BaseFactory || (ɵButton_BaseFactory = i0.ɵɵgetInheritedFactory(Button)))(__ngFactoryType__ || Button);
      };
    })();
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: Button,
      selectors: [["p-button"]],
      contentQueries: function Button_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, _c0, 5)(dirIndex, _c1, 5)(dirIndex, _c2, 5)(dirIndex, PrimeTemplate, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.contentTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.loadingIconTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.iconTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.templates = _t);
        }
      },
      inputs: {
        hostName: "hostName",
        type: "type",
        badge: "badge",
        disabled: [2, "disabled", "disabled", booleanAttribute],
        raised: [2, "raised", "raised", booleanAttribute],
        rounded: [2, "rounded", "rounded", booleanAttribute],
        text: [2, "text", "text", booleanAttribute],
        plain: [2, "plain", "plain", booleanAttribute],
        outlined: [2, "outlined", "outlined", booleanAttribute],
        link: [2, "link", "link", booleanAttribute],
        tabindex: [2, "tabindex", "tabindex", numberAttribute],
        size: "size",
        variant: "variant",
        style: "style",
        styleClass: "styleClass",
        badgeClass: "badgeClass",
        badgeSeverity: "badgeSeverity",
        ariaLabel: "ariaLabel",
        autofocus: [2, "autofocus", "autofocus", booleanAttribute],
        iconPos: "iconPos",
        icon: "icon",
        label: "label",
        loading: [2, "loading", "loading", booleanAttribute],
        loadingIcon: "loadingIcon",
        severity: "severity",
        buttonProps: "buttonProps",
        fluid: [1, "fluid"]
      },
      outputs: {
        onClick: "onClick",
        onFocus: "onFocus",
        onBlur: "onBlur"
      },
      features: [i0.ɵɵProvidersFeature([ButtonStyle, {
        provide: BUTTON_INSTANCE,
        useExisting: Button
      }, {
        provide: PARENT_INSTANCE,
        useExisting: Button
      }]), i0.ɵɵHostDirectivesFeature([i1.Bind]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c3,
      decls: 7,
      vars: 17,
      consts: [["pRipple", "", 3, "click", "focus", "blur", "ngStyle", "disabled", "pAutoFocus", "pBind"], [4, "ngTemplateOutlet"], [4, "ngIf"], [3, "class", "pBind", 4, "ngIf"], [3, "value", "severity", "pt", "unstyled", 4, "ngIf"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["data-p-icon", "spinner", 3, "class", "pBind", "spin", 4, "ngIf"], [3, "pBind"], ["data-p-icon", "spinner", 3, "pBind", "spin"], [3, "ngIf"], [3, "value", "severity", "pt", "unstyled"]],
      template: function Button_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "button", 0);
          i0.ɵɵlistener("click", function Button_Template_button_click_0_listener($event) {
            return ctx.onClick.emit($event);
          })("focus", function Button_Template_button_focus_0_listener($event) {
            return ctx.onFocus.emit($event);
          })("blur", function Button_Template_button_blur_0_listener($event) {
            return ctx.onBlur.emit($event);
          });
          i0.ɵɵprojection(1);
          i0.ɵɵtemplate(2, Button_ng_container_2_Template, 1, 0, "ng-container", 1)(3, Button_ng_container_3_Template, 3, 6, "ng-container", 2)(4, Button_ng_container_4_Template, 3, 6, "ng-container", 2)(5, Button_span_5_Template, 2, 6, "span", 3)(6, Button_p_badge_6_Template, 1, 4, "p-badge", 4);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.cn(ctx.cx("root"), ctx.styleClass, ctx.buttonProps == null ? null : ctx.buttonProps.styleClass));
          i0.ɵɵproperty("ngStyle", ctx.style || (ctx.buttonProps == null ? null : ctx.buttonProps.style))("disabled", ctx.disabled || ctx.loading || (ctx.buttonProps == null ? null : ctx.buttonProps.disabled))("pAutoFocus", ctx.autofocus || (ctx.buttonProps == null ? null : ctx.buttonProps.autofocus))("pBind", ctx.ptm("root"));
          i0.ɵɵattribute("type", ctx.type || (ctx.buttonProps == null ? null : ctx.buttonProps.type))("aria-label", ctx.ariaLabel || (ctx.buttonProps == null ? null : ctx.buttonProps.ariaLabel))("tabindex", ctx.tabindex || (ctx.buttonProps == null ? null : ctx.buttonProps.tabindex))("data-p", ctx.dataP)("data-p-disabled", ctx.disabled || ctx.loading || (ctx.buttonProps == null ? null : ctx.buttonProps.disabled))("data-p-severity", ctx.severity || (ctx.buttonProps == null ? null : ctx.buttonProps.severity));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngTemplateOutlet", ctx.contentTemplate || ctx._contentTemplate);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.loading || (ctx.buttonProps == null ? null : ctx.buttonProps.loading));
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !(ctx.loading || (ctx.buttonProps == null ? null : ctx.buttonProps.loading)));
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.contentTemplate && !ctx._contentTemplate && (ctx.label || (ctx.buttonProps == null ? null : ctx.buttonProps.label)));
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.contentTemplate && !ctx._contentTemplate && (ctx.badge || (ctx.buttonProps == null ? null : ctx.buttonProps.badge)));
        }
      },
      dependencies: [CommonModule, i2.NgIf, i2.NgTemplateOutlet, i2.NgStyle, Ripple, AutoFocus, SpinnerIcon, BadgeModule, i3.Badge, SharedModule, Bind],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return Button;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ButtonModule = /*#__PURE__*/(() => {
  class ButtonModule {
    static ɵfac = function ButtonModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ButtonModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ButtonModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, Button, SharedModule, SharedModule]
    });
  }
  return ButtonModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// Backward compatibility

/**
 * Generated bundle index. Do not edit.
 */

export { Button, ButtonClasses, ButtonDirective, ButtonIcon, ButtonLabel, ButtonModule, ButtonStyle };
